import {NgModule} from '@angular/core';
import {DataProcessingAgreementService} from './services/data-processing-agreement.service';
import {CommonModule} from '@angular/common';
import {IDataProcessingAgreementHttpService} from './services/data-processing-agreement.http.service.interface';
import {DataProcessingAgreementHttpService} from './services/data-processing-agreement.http.dealerapp.service.implementation';
import {
    ModalDataProcessingAgreementNewComponent
} from './components/modal-services-data-processing-agreement-new/modal-data-processing-agreement-new.component';
import {
    ModalDataProcessingAgreementNotConfirmedInfoComponent
} from './components/modal-data-procesing-agreement-not-confirmed-info/modal-data-procesing-agreement-not-confirmed-info.component';
import {BDProjectsModule, BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {FormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        BDProjectsModule,
        BDSharedModule,
        FormsModule,

    ],
    declarations: [
        ModalDataProcessingAgreementNewComponent,
        ModalDataProcessingAgreementNotConfirmedInfoComponent,
    ],
    exports: [
    ],
    providers: [
        DataProcessingAgreementService,
        {provide: IDataProcessingAgreementHttpService, useClass: DataProcessingAgreementHttpService},
    ]
})
export class DataProcessingAgreementModule {
}
